import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const productCard = tv({
  slots: {
    root: 'relative flex w-full flex-1 flex-col overflow-hidden border border-solid',
    cover: 'relative z-10 flex w-full flex-col overflow-hidden',
    tagList: 'absolute right-0 top-0 z-10 flex flex-row flex-wrap gap-x-1 p-2.5',
    tag: [
      caption({ bold: true }),
      'flex items-center justify-center rounded-[20px] border border-solid px-4 py-2',
    ],
    coverImage: 'h-full w-full object-cover',
    header: 'flex flex-1 flex-row items-start gap-x-2.5 p-4',
    headerTextContainer: 'flex flex-1 flex-col gap-y-1',
    content: 'relative flex w-full flex-col px-4 pb-4 pt-1',
    footer: 'grid w-full grid-flow-col gap-4 px-4 pb-4 pt-1',
  },
})
